(() => {
  const root = document.querySelector("[data-dq]");
  if (!root) return;

  const form = root.querySelector("[data-dq-form]");
  if (!form) return;

  const stepsWrap = form.querySelector("[data-dq-steps]");
  const steps = Array.from(form.querySelectorAll("[data-dq-step]"));
  const btnBack = form.querySelector("[data-dq-back]");
  const btnNext = form.querySelector("[data-dq-next]");
  const btnFinish = form.querySelector("[data-dq-finish]");
  const progressEl = form.querySelector("[data-dq-progress]");

  const DRAFT_KEY = "dq_draft_v1";

  let stepIndex = 0;

  // ---------- helpers ----------
  const $all = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function getState() {
    const fd = new FormData(form);

    const state = {};
    for (const [k, v] of fd.entries()) {
      if (k === "illness_list" || k === "symptom_list") {
        if (!state[k]) state[k] = [];
        state[k].push(v);
      } else {
        state[k] = v;
      }
    }
    return state;
  }

  function saveDraft() {
    try {
      localStorage.setItem(DRAFT_KEY, JSON.stringify(getState()));
    } catch (e) {}
  }

  function loadDraft() {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function applyState(state) {
    if (!state) return;

    for (const [key, value] of Object.entries(state)) {
      const els = $all(`[name="${CSS.escape(key)}"]`, form);
      if (!els.length) continue;

      if (els[0].type === "radio") {
        els.forEach((r) => (r.checked = r.value === value));
      } else if (els[0].type === "checkbox") {
        const vals = Array.isArray(value) ? value : [value];
        els.forEach((c) => (c.checked = vals.includes(c.value)));
      } else {
        els[0].value = value;
      }
    }
  }

  function setTokens() {
    const state = getState();
    $all("[data-dq-token]", form).forEach((el) => {
      const key = el.getAttribute("data-dq-token");
      el.textContent = state[key] || "";
    });
  }

  function clearStepErrors(stepEl) {
    $all("[data-dq-error]", stepEl).forEach((e) => (e.textContent = ""));
  }

  function showStep(i) {
    const state = getState();

    // Hide steps that don't apply (e.g., dog-only steps if shopping_for=cat)
    steps.forEach((s) => {
      const only = s.getAttribute("data-dq-only");
      if (!only) return;

      const shouldShow = (state.shopping_for || "dog") === only;
      s.dataset.dqDisabled = shouldShow ? "0" : "1";
    });

    // Move to the next enabled step if current is disabled
    const enabledSteps = steps.filter((s) => s.dataset.dqDisabled !== "1");
    if (!enabledSteps.length) return;

    if (i < 0) i = 0;
    if (i >= enabledSteps.length) i = enabledSteps.length - 1;

    enabledSteps.forEach((s) => (s.hidden = true));
    enabledSteps[i].hidden = false;

    stepIndex = i;

    btnBack.hidden = stepIndex === 0;
    btnNext.hidden = stepIndex === enabledSteps.length - 1;
    btnFinish.hidden = stepIndex !== enabledSteps.length - 1;

    progressEl.textContent = String(stepIndex + 1);

    setTokens();
    updateConditionals();
    saveDraft();
  }

  function updateConditionals() {
    const state = getState();

    $all("[data-dq-when]", form).forEach((wrap) => {
      const rule = wrap.getAttribute("data-dq-when"); // e.g. "has_illness:yes"
      const [field, expected] = rule.split(":");
      const actual = state[field];

      wrap.hidden = actual !== expected;
    });
  }

  function validateStep() {
    const enabledSteps = steps.filter((s) => s.dataset.dqDisabled !== "1");
    const stepEl = enabledSteps[stepIndex];
    if (!stepEl) return true;

    clearStepErrors(stepEl);

    // 1) native required inputs
    const required = $all("[required]", stepEl).filter((el) => !el.closest("[hidden]"));

    // Validate radio groups by name
    const radioNames = new Set(required.filter((el) => el.type === "radio").map((r) => r.name));
    for (const name of radioNames) {
      const group = $all(`[name="${CSS.escape(name)}"]`, stepEl);
      const anyChecked = group.some((r) => r.checked);
      if (!anyChecked) {
        const err = stepEl.querySelector("[data-dq-error]");
        if (err) err.textContent = "Please select an option to continue.";
        return false;
      }
    }

    // Validate text/number/email required fields
    for (const el of required) {
      if (el.type === "radio" || el.type === "checkbox") continue;

      const val = (el.value || "").trim();
      if (!val) {
        const err = stepEl.querySelector("[data-dq-error]");
        if (err) err.textContent = "This field is required.";
        el.focus();
        return false;
      }

      if (el.type === "email") {
        const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
        if (!ok) {
          const err = stepEl.querySelector("[data-dq-error]");
          if (err) err.textContent = "Please enter a valid email address.";
          el.focus();
          return false;
        }
      }

      if (el.type === "number") {
        const n = Number(val);
        if (!Number.isFinite(n) || n <= 0) {
          const err = stepEl.querySelector("[data-dq-error]");
          if (err) err.textContent = "Please enter a valid number.";
          el.focus();
          return false;
        }
      }
    }

    // 2) Conditional checkbox lists: if yes, at least one checkbox required
    const state = getState();

    if (stepEl.getAttribute("data-dq-step") === "11" && state.has_illness === "yes") {
      const checked = $all('input[name="illness_list"]:checked', stepEl);
      if (!checked.length) {
        const err = stepEl.querySelector('[data-dq-when="has_illness:yes"] [data-dq-error]');
        if (err) err.textContent = "Please select at least one option.";
        return false;
      }
    }

    if (stepEl.getAttribute("data-dq-step") === "12" && state.has_symptoms === "yes") {
      const checked = $all('input[name="symptom_list"]:checked', stepEl);
      if (!checked.length) {
        const err = stepEl.querySelector('[data-dq-when="has_symptoms:yes"] [data-dq-error]');
        if (err) err.textContent = "Please select at least one option.";
        return false;
      }
    }

    return true;
  }

  // ---------- events ----------
  form.addEventListener("input", () => {
    setTokens();
    updateConditionals();
    saveDraft();
  });

  btnBack.addEventListener("click", () => {
    const enabledSteps = steps.filter((s) => s.dataset.dqDisabled !== "1");
    showStep(stepIndex - 1 < 0 ? 0 : stepIndex - 1);
    enabledSteps[stepIndex]?.scrollIntoView({ block: "start", behavior: "smooth" });
  });

  btnNext.addEventListener("click", () => {
    if (!validateStep()) return;
    showStep(stepIndex + 1);
    stepsWrap.scrollIntoView({ block: "start", behavior: "smooth" });
  });

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (!validateStep()) return;

    const payload = getState();
    // For now: just confirm in console and keep draft.
    console.log("DOG QUIZ SUBMIT", payload);

    // Next phase: POST payload to an App Proxy endpoint and persist to metaobjects/customer metafields.
    // fetch("/apps/dog-quiz/save", { method:"POST", headers:{ "Content-Type":"application/json" }, body: JSON.stringify(payload) })

    alert("Saved (draft). Next step: persist to Shopify metaobjects.");
  });

  // ---------- init ----------
  applyState(loadDraft());
  showStep(0);
})();